import { NavLink } from 'react-router-dom';

import builtOnSureLogo from './built-on-sure-logo.svg';
import classes from './NavBar.module.css';
import { TMenuLink } from './NavMenuList';

export type TFooterLinks = {
  footerLinks: Pick<TMenuLink, 'to' | 'title'>[];
};

function NavFooter({ footerLinks = [] }: TFooterLinks) {
  return (
    <div className={classes.menu_footer}>
      <div className={classes.menu_footer_social}>
        <a
          href="https://www.facebook.com/toggleinsurance"
          className={classes.menu_footer_social_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-facebook-f" />
        </a>
        <a
          href="https://www.instagram.com/toggleinsurance"
          className={classes.menu_footer_social_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram" />
        </a>
      </div>
      <a
        href="https://www.sureapp.com"
        rel="noopener noreferrer"
        className={classes.menu_footer_builtOnSure}
      >
        <img src={builtOnSureLogo} alt="Built on Sure logo" />
      </a>
      {footerLinks && (
        <div className={classes.menu_footer_pages}>
          {footerLinks.map((footerLink) => (
            <NavLink
              key={footerLink.to}
              className={classes.menu_footer_pages_link}
              to={footerLink.to}
            >
              {footerLink.title}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export default NavFooter;
